import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { ImSpinner3 } from 'react-icons/im';
import { API_BASE_URL } from '../../lib/constants';

const LoadingSpinner = () => (
  <div className="fixed inset-0 flex items-center justify-center bg-teal-800 bg-opacity-50 z-50">
    <ImSpinner3 className="animate-spin text-white text-4xl" />
    <p className="mt-4 text-white">Checking access...</p>
  </div>
);

const ProtectedRoute = ({ allowedRoles = [], allowedPermissions = [], children }) => {
  const location = useLocation();
  const [authChecked, setAuthChecked] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userRole, setUserRole] = useState(null);
  const [permissions, setPermissions] = useState([]);


  useEffect(() => {
    const checkAuth = async () => {
      const params = new URLSearchParams(location.search);
      const token = params.get('token');

      if (token) {
        setIsAuthenticated(true);
        setUserRole('TokenAccess');
        setPermissions([]);

        setAuthChecked(true);
        return;
      }

      try {
        const res = await axios.get(`${API_BASE_URL}/auth/verify`, {
          withCredentials: true,
        });

        if (res.data.status === 'authenticated') {
          setIsAuthenticated(true);
          setUserRole(res.data.role);
          setPermissions(res.data.permissions || []);

        } else {
          setIsAuthenticated(false);
        }
      } catch (err) {
        setIsAuthenticated(false);
      } finally {
        setAuthChecked(true);
      }
    };

    checkAuth();
  }, [location.search]);

  if (!authChecked) return <LoadingSpinner />;

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // Admin bypass
  if (userRole === 'Admin') return children;

  const isTokenAccess = userRole === 'TokenAccess';

  // Check role
  if (!isTokenAccess && allowedRoles.length && !allowedRoles.includes(userRole)) {
    return <Navigate to="/unauthorized" replace />;
  }

  // Check permissions
  if (!isTokenAccess && allowedPermissions.length) {
    const hasPermission = allowedPermissions.some(p => permissions.includes(p));
    if (!hasPermission) {
      return <Navigate to="/unauthorized" replace />;
    }
  }

  // Optionally pass hospitalId as prop if children is a function or use context
  // Here just rendering children directly
  return children;
};

export default ProtectedRoute;
